import { PlacementError } from './PlacementError';

/**
 * Error thrown when a saved publisher organization has no publishing days configured.
 */
export class MissingPublishingDaysError extends PlacementError {
  constructor(message = 'Saved publisher has no publication days configured') {
    super(message);
    this.name = 'MissingPublishingDaysError';
  }
}
